import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, ArrowRight } from "lucide-react";
import { nav, company } from "../mock";
import Logo from "./Logo";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-3 sm:px-5 pt-3">
      <div
        className={`max-w-6xl mx-auto rounded-2xl transition-all duration-300 ${
          scrolled
            ? "bg-white/85 backdrop-blur-xl shadow-[0_10px_30px_-15px_rgba(26,23,20,0.35)] border border-white/60"
            : "bg-white/70 backdrop-blur-md border border-white/40"
        }`}
      >
        <div className="flex items-center justify-between h-16 px-4 sm:px-6">
          <Link to="/" aria-label="iClean home"><Logo /></Link>

          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((item) => {
              const active = pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-full text-[15px] font-medium transition-all duration-200 ${
                    active ? "bg-[#ea731d]/12 text-[#ea731d]" : "text-[#1a1714] hover:bg-black/5"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href={company.phoneHref} className="text-sm font-semibold text-[#1a1714] hover:text-[#ea731d] transition-colors flex items-center gap-1.5">
              <Phone size={15} /> {company.phone}
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 bg-[#ea731d] hover:bg-[#d9640f] text-white font-semibold text-sm px-5 py-2.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 brand-shadow"
            >
              Get a quote <ArrowRight size={16} />
            </Link>
          </div>

          <button className="lg:hidden p-2 text-[#1a1714]" onClick={() => setOpen((o) => !o)} aria-label="Toggle menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? "max-h-96" : "max-h-0"}`}>
          <nav className="px-5 pb-5 pt-1 flex flex-col gap-1">
            {nav.map((item) => {
              const active = pathname === item.path;
              return (
                <Link key={item.path} to={item.path}
                  className={`px-4 py-3 rounded-xl text-base font-medium ${active ? "bg-[#ea731d]/12 text-[#ea731d]" : "text-[#1a1714] hover:bg-black/5"}`}>
                  {item.label}
                </Link>
              );
            })}
            <Link to="/contact" className="mt-2 inline-flex items-center justify-center gap-2 bg-[#ea731d] text-white font-semibold px-5 py-3 rounded-xl">
              Get a quote <ArrowRight size={17} />
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
